<template lang="pug" src="./nav-desktop.pug"></template>

<script>
export default {
  data () {
    return {
      linkActive: false,
      index: ''
    }
  },
  computed: {
    links () {
      return this.$router.options.routes
    }
  },
  methods: {
    handleEnter (i) {
      this.linkActive = true
      this.index = i
    },
    handleLeave () {
      this.linkActive = false
      this.index = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/nav-desktop/nav-desktop.vue